var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 296 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H296L273.661 41.8394C268.157 52.1494 265.405 57.3043 260.656 60.1522C255.907 63 250.063 63 238.376 63H57.6242C45.9367 63 40.093 63 35.3442 60.1522C30.5954 57.3043 27.8431 52.1494 22.3385 41.8394L0 0Z",
    fill: "url(#paint0_linear_74_24480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_24480",
    x1: 151.06,
    y1: 63.094,
    x2: 151.06,
    y2: 14.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37A9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437084",
    stopOpacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title_bg.48083ead8c76ca9982b4b4d08766f7de.svg";
export { ForwardRef as ReactComponent };